$shm_check_list $mol_list
	options /string
	value? /string
	rows /
		<= All $shm_check_all
			title \Все
			checks <= checks
			checked? <=> all_checked? false
		<= Checks $mol_list
			rows <= checks /
	Check* $mol_check_box
		title <= check_title* \
		checked? <=> checked*? false
